import { Button, Flex, ModuleLayout, SkeletonBox, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetchZervantSubscription } from '@features/zervant-subscription/hooks/useFetchZervantSubscription'
import { useOpenZervantPortal } from '@features/zervant-subscription/hooks/useOpenZervantPortal'

import { getImageClassName } from '../../utils/getClassName'
import { getImgPath } from '../../utils/getImgPath'
import * as Styled from './styles'

const PAST_DUE_STATUS = 'past_due'

export const StripeOverdueInvoiceLockedView = (): ReactElement => {
  const { t } = useTranslation()
  const { openPortal, isLoading: isOpeningPortal } = useOpenZervantPortal()
  const { zervantSubscription, isLoading: isSubscriptionLoading } = useFetchZervantSubscription()

  if (isSubscriptionLoading) {
    return <SkeletonBox height={400} fullWidth />
  }

  const isPastDue =
    zervantSubscription?.status === PAST_DUE_STATUS && (zervantSubscription?.payment?.dueInvoices?.length ?? 0) > 0

  return (
    <ModuleLayout fullHeight>
      <Styled.Container>
        <Styled.ContentWrapper>
          <Flex flexDirection="column" alignItems="center">
            <Text variant="h1" alignment="center">
              {t('organization.stripe_locked.title')}
            </Text>
            <Space size="s16" />
            <Text alignment="center">
              {isPastDue
                ? t('organization.stripe_locked.description_past_due')
                : t('organization.stripe_locked.description')}
            </Text>
            <Space size="s24" />
            <Button loading={isOpeningPortal} onClick={() => openPortal()}>
              {t('organization.stripe_locked.pay_button')}
            </Button>
            <Space size="s80" />
            <img
              src={getImgPath('/modals/key-and-lock.svg')}
              width={284}
              height={253}
              className={getImageClassName()}
              alt={t('organization.not_owner_and_overdue_invoice.key_and_lock_illustration_description')}
            />
          </Flex>
        </Styled.ContentWrapper>
      </Styled.Container>
    </ModuleLayout>
  )
}
